import { ButtonSize, ButtonIconSize } from '@src/types/buttons';
import {
  COLOR_LIME,
  COLOR_WHITE,
  COLOR_OUTERSPACE,
  COLOR_SIDECAR,
  ButtonColors,
  COLOR_EARLS_GREEN_DARK
} from '@src/types/colors';

export const getButtonColorClasses = (
  color: ButtonColors,
  outline: boolean,
  styles: any
): { [x: number]: boolean } => ({
  [styles.limeButton]: color === COLOR_LIME && !outline,
  [styles.limeOutlineButton]: color === COLOR_LIME && !!outline,
  [styles.outerspaceButton]: color === COLOR_OUTERSPACE && !outline,
  [styles.outerspaceOutlineButton]: color === COLOR_OUTERSPACE && !!outline,
  [styles.sidecarButton]: color === COLOR_SIDECAR && !outline,
  [styles.sidecarOutlineButton]: color === COLOR_SIDECAR && !!outline,
  [styles.whiteButton]: color === COLOR_WHITE && !outline,
  [styles.whiteOutlineButton]: color === COLOR_WHITE && !!outline,
  [styles.earlsGreenDarkButton]: color === COLOR_EARLS_GREEN_DARK && !outline,
  [styles.earlsGreenDarkOutlineButton]:
    color === COLOR_EARLS_GREEN_DARK && !!outline
});

export const getButtonClasses = (
  color: ButtonColors,
  buttonSize: ButtonSize,
  outline: boolean,
  styles: any
): { [x: number]: boolean } => {
  const colorClasses = getButtonColorClasses(color, outline, styles);
  return {
    [styles.button]: true,
    [styles.large]: buttonSize === 'lg',
    [styles.medium]: buttonSize === 'md',
    [styles.small]: buttonSize === 'sm',
    [styles.auto]: buttonSize === 'auto',
    ...colorClasses
  };
};

export const getButtonPillColorClasses = (
  variant: ButtonColors,
  styles: any
): { [x: number]: boolean } => ({
  [styles.outerspaceButtonPill]: variant === COLOR_OUTERSPACE,
  [styles.sidecarButtonPill]: variant === COLOR_SIDECAR,
  [styles.limeButtonPill]: variant === COLOR_LIME,
  [styles.whiteButtonPill]: variant === COLOR_WHITE,
  [styles.earlsGreenDarkButtonPill]: variant === COLOR_EARLS_GREEN_DARK
});

export const getButtonPillClasses = (
  color: ButtonColors,
  styles: any
): { [x: number]: boolean } => {
  const colorClasses = getButtonPillColorClasses(color, styles);
  return {
    [styles.buttonPill]: true,
    ...colorClasses
  };
};

export const getButtonIconClasses = (
  color: ButtonColors,
  buttonSize: ButtonIconSize,
  outline: boolean,
  styles: any
): { [x: number]: boolean } => {
  const colorStyles = getButtonColorClasses(color, outline, styles);
  return {
    [styles.buttonIcon]: true,
    [styles.buttonIconXXLarge]: buttonSize === 'xxl',
    [styles.buttonIconXLarge]: buttonSize === 'xl',
    [styles.buttonIconLarge]: buttonSize === 'lg',
    [styles.buttonIconMedium]: buttonSize === 'md',
    [styles.buttonIconSmall]: buttonSize === 'sm',
    [styles.buttonIconXSmall]: buttonSize === 'xs',
    ...colorStyles
  };
};

// * The padding works differently on an <a> than a <button>
// * So the particular ButtonLinkIcon styles style the svg size inside the link, instead of using padding
export const getButtonLinkIconClasses = (
  color: ButtonColors,
  buttonSize: ButtonIconSize,
  outline: boolean,
  styles: any
): { [x: number]: boolean } => {
  const colorStyles = getButtonColorClasses(color, outline, styles);
  return {
    [styles.buttonIcon]: true,
    [styles.buttonLinkIconXXLarge]: buttonSize === 'xxl',
    [styles.buttonLinkIconXLarge]: buttonSize === 'xl',
    [styles.buttonLinkIconLarge]: buttonSize === 'lg',
    [styles.buttonLinkIconMedium]: buttonSize === 'md',
    [styles.buttonLinkIconSmall]: buttonSize === 'sm',
    [styles.buttonLinkIconXSmall]: buttonSize === 'xs',
    ...colorStyles
  };
};
